import { computed, defineComponent, onMounted, ref, watch, } from '@vue/composition-api';
import { getGoodsAndServices, } from '@/api/v2/requests/goods-offers';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import NoResults from '@/views/_components/NoResults.vue';
import TablePaginationV2 from '@/views/_components/Table/TablePaginationV2.vue';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import OfferExpandableCard from '@/views/Brand/Applications/Components/Offers/OfferExpandableCard.vue';
import { useGoodsAndServicesColumns } from '@/views/Brand/Applications/Offer/_composables/use-goods-and-services-columns';
import { GOODS_OFFER_STATUS_DOT_COLORS } from '@/views/Brand/Applications/Offer/_components/GoodsOfferStatusCell/goods-offer-status-cell.constants';
import TotalCostCell from '@/views/Brand/Applications/Components/Offers/Contracts/_components/TotalCostCell.vue';
export default defineComponent({
    name: 'OfferGoodsAndServices',
    components: {
        OfferExpandableCard,
        TablePaginationV2,
        TableLoader,
        NoResults,
        AgTable: GenericAGTable(),
        // eslint-disable-next-line vue/no-unused-components
        TotalCostCell,
    },
    props: {
        goodsOfferId: {
            type: String,
            required: true,
        },
        goodsOfferStatus: {
            type: String,
            required: false,
            default: null,
        },
    },
    setup(props, ctx) {
        const isLoading = ref(false);
        const rows = ref([]);
        const totalCount = ref(0);
        const page = ref(1);
        const { columns } = useGoodsAndServicesColumns(ctx, {
            rows,
        });
        const pinnedRows = computed(() => {
            return rows.value.length > 0 ? [{ id: 'total-cost' }] : [];
        });
        const dotColor = computed(() => {
            return GOODS_OFFER_STATUS_DOT_COLORS[props.goodsOfferStatus];
        });
        const statusTitle = computed(() => {
            if (!props.goodsOfferStatus) {
                return ctx.root.$t('goods-and-services.title').toString();
            }
            return ctx.root
                .$t(`goods-offer-status.${props.goodsOfferStatus}`)
                .toString();
        });
        const objectQuery = computed(() => {
            return {
                page: page.value,
                perPage: 500,
            };
        });
        const fetchItems = async () => {
            if (!props.goodsOfferId)
                return;
            isLoading.value = true;
            try {
                const queryParams = {
                    page: page.value,
                    perPage: 500,
                };
                const { nodes, totalCount: nodesCount } = await getGoodsAndServices(props.goodsOfferId, queryParams);
                totalCount.value = nodesCount;
                rows.value = nodes;
            }
            catch (err) {
                ctx.root.$toast.error(ctx.root.$t('goods-and-services.error-fetching').toString());
                console.error('Error fetching goods and services:', err);
            }
            finally {
                isLoading.value = false;
            }
        };
        onMounted(async () => {
            await fetchItems();
        });
        watch(() => props.goodsOfferId, () => {
            if (props.goodsOfferId) {
                fetchItems();
            }
        });
        watch(page, async () => {
            await fetchItems();
        });
        const hasGoodsAndServices = computed(() => {
            return rows.value && rows.value.length > 0;
        });
        return {
            page,
            columns,
            objectQuery,
            rows,
            isLoading,
            totalCount,
            hasGoodsAndServices,
            dotColor,
            statusTitle,
            pinnedRows,
        };
    },
});
